import React from 'react'
import WissensportalAzubi from '#components/o/Wissensportal/WissensportalAzubi'
import WissensportalAusbilderTrainer from '#components/o/Wissensportal/WissensportalAusbilderTrainer'
import {usePermissions} from '#hooks/usePermissions'
import {useParams} from "react-router-dom";

export const Wissensportal = () => {
  const {azubiId} = useParams()
  const permissions = usePermissions()
  return permissions.wissensportal.viewWissensportalFromOthers ? (
    <WissensportalAusbilderTrainer azubiId={Number(azubiId)} />
  ) : (
    <WissensportalAzubi />
  )
}

export default Wissensportal
